import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { TextButton } from '../text-button/text-button';
export var FormTitle = function (_a) {
    var title = _a.title, _b = _a.isBtnEnabled, isBtnEnabled = _b === void 0 ? true : _b, actionLabel = _a.actionLabel, onActionClick = _a.onActionClick, dataTestIdBtn = _a.dataTestIdBtn, dataTestIdTitle = _a.dataTestIdTitle;
    var actionBtn = (React.createElement(TextButton, { onClick: onActionClick, "date-testid": dataTestIdBtn }, actionLabel));
    return (React.createElement("div", { className: "sui-flex sui-justify-between" },
        React.createElement(Typography, { variant: "h2", weight: "condensed", "data-testid": dataTestIdTitle }, title),
        isBtnEnabled && actionLabel && actionBtn));
};
